import { Component, input } from '@angular/core';

@Component({
  selector: 'app-character-count',
  host: {
    class: 'block'
  },
  template: `
    <p aria-atomic="true" aria-live="polite" class="mt-1 text-right text-xs text-gray-500 tabular-nums">
      {{ value().length }} / {{ max() }}
    </p>
  `
})
export class CharacterCountComponent {
  value = input.required<string>();
  max = input.required<number>();
}
